import { render } from "./QuestionFeedback.vue?vue&type=template&id=3f489438&scoped=true"
import script from "./QuestionFeedback.vue?vue&type=script&lang=js"
export * from "./QuestionFeedback.vue?vue&type=script&lang=js"

import "./QuestionFeedback.vue?vue&type=style&index=0&id=3f489438&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f489438"]])

export default __exports__